/**
 * Yayın sonrası eski JS ile yeni parçanın karışması.
 *
 * Açık kalan sekme eski webpack bellek defterini tutar; menüden başka ekrana geçince
 * (veya Next o ekranı önden çekince) yeni parça eski numaralarla çalıştırılır. Fabrika
 * yoktur, `.call` patlar. Bu gerçek bir ekran hatası değil; sayfayı bir kez tam yüklemek
 * yeter. Uygulama kodundaki `undefined.call` ile karışmasın diye yığında webpack izi
 * aranır. Oturumda ikinci kez yenilenmez — asıl bir hata varsa döngüye girilmez.
 */

const OTURUM_KILIDI = 'opasEskiPaketYenilendi'

const CALL_KAYMASI =
  /cannot read propert(?:y|ies) of undefined \(reading ['"]call['"]\)/i

const PARCA_YUKLEME =
  /chunkloaderror|loading chunk|failed to fetch dynamically imported module|failed to load chunk/i

const WEBPACK_IZI = /[\\/]webpack[-.]|chunks\/webpack/i

export function eskiPaketKaymasiMi(tur: string, mesaj: string, yiginIzi?: string): boolean {
  if (tur === 'ChunkLoadError' || PARCA_YUKLEME.test(tur) || PARCA_YUKLEME.test(mesaj)) {
    return true
  }
  if (!CALL_KAYMASI.test(mesaj)) return false
  return WEBPACK_IZI.test(yiginIzi ?? '')
}

/** Eşleşirse oturumda bir kez yeniler. Kilidi yazamazsa yenilemez — sonsuz döngü olmasın. */
export function eskiPaketiBirKezYenile(): void {
  try {
    if (sessionStorage.getItem(OTURUM_KILIDI) === '1') return
    sessionStorage.setItem(OTURUM_KILIDI, '1')
  } catch {
    return
  }
  window.location.reload()
}
